import { render, staticRenderFns } from "./userlist.vue?vue&type=template&id=0048a3ce&"
import script from "./userlist.vue?vue&type=script&lang=ts&"
export * from "./userlist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports